var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMine)?[_c('div',{class:[
            'message-initiator',
            {
                'padding-r-4': _vm.showAvatar
            }
        ]},[(_vm.showAvatar)?_c('div',{staticClass:"message-initiator_left"},[_c('img',{class:[
                    'message-avatar',
                    {
                        'circular-avatar': _vm.circular,
                        'avatar-32': _vm.size === 'small',
                        'avatar-36': _vm.size === 'middle'
                    }
                ],attrs:{"src":_vm.avatar || _vm.avatarList[_vm.avatarType]}})]):_vm._e(),_c('div',{staticClass:"message-initiator_right"},[(_vm.showNick)?_c('div',{staticClass:"message-initiator_title"},[_vm._v(_vm._s(_vm.nick))]):_vm._e(),_c('div',{staticClass:"message-initiator_content"},[_vm._t("default")],2)])])]:[_c('div',{staticClass:"message-receive padding-l-4"},[_c('div',{staticClass:"message-receive_left"},[(_vm.showNick)?_c('div',{staticClass:"message-receive_title"},[_vm._v(_vm._s(_vm.nick))]):_vm._e(),_c('div',{staticClass:"message-receive_content"},[_vm._t("default")],2)]),(_vm.showAvatar)?_c('div',{staticClass:"message-receive_right"},[_c('img',{class:[
                    'message-avatar',
                    {
                        'circular-avatar': _vm.circular,
                        'avatar-32': _vm.size === 'small',
                        'avatar-36': _vm.size === 'middle'
                    }
                ],attrs:{"src":_vm.avatar || _vm.avatarList[_vm.avatarType]}})]):_vm._e()])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }